export const HelloReact = (): JSX.Element => {
  return (
    <h1>Hello, React!</h1>
  )
}
